var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.208,
    height: 13.206,
    viewBox: "0 0 19.208 13.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card",
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33798",
    "data-name": "Path 33798",
    d: "M17.107,80H2.1A2.1,2.1,0,0,0,0,82.1v9a2.1,2.1,0,0,0,2.1,2.1H17.107a2.1,2.1,0,0,0,2.1-2.1v-9A2.1,2.1,0,0,0,17.107,80ZM2.1,81.2H17.107a.9.9,0,0,1,.9.9v1.2H1.2V82.1A.9.9,0,0,1,2.1,81.2Zm15.007,10.8H2.1a.9.9,0,0,1-.9-.9V84.5H18.008v6.6A.9.9,0,0,1,17.107,92.005Z",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33799",
    "data-name": "Path 33799",
    d: "M81.324,305.985h-.662a.662.662,0,0,1-.662-.662v-.662a.662.662,0,0,1,.662-.662h.662a.662.662,0,0,1,.662.662v.662A.662.662,0,0,1,81.324,305.985Z",
    transform: "translate(-77.031 -215.732)",
    fill: "#bcbcbc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.6264a50ce8976b02e4aa261eb30c501a.svg";
export { ForwardRef as ReactComponent };